function getLineHeight(el) {
  const {
    lineHeight,
    fontSize
  } = window.getComputedStyle(el);
  if (lineHeight === 'normal') {
    return parseInt(fontSize, 10) * 1.2;
  }
  return parseFloat(lineHeight);
}
function getLastTextNode(el) {
  let node;
  const walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
  while (node = walk.nextNode()) {
    if (node && node.childNodes && !node.childNodes.length) {
      node = node;
      break;
    }
  }
  return node;
}
function truncateTextNode(textNode, el, maxHeight) {
  let {
    textContent
  } = textNode;
  textNode.textContent = '';
  if (el.clientHeight > maxHeight) {
    return false;
  }
  const words = textContent.split(' ');
  while (words.pop()) {
    textNode.textContent = words.join(' ');
    if (el.clientHeight <= maxHeight) {
      textNode.textContent = textContent;
      break;
    }
    textContent = textNode.textContent;
  }
  let {
    length
  } = textContent;
  while (length > 1) {
    textContent = textContent.substring(0, --length);
    textNode.textContent = `${textContent}\u2026`;
    if (el.clientHeight <= maxHeight) {
      return true;
    }
  }
  return false;
}
function truncate(el, lineCount) {
  const lineHeight = getLineHeight(el);
  const maxHeight = Math.round(lineHeight * lineCount);
  if (el.clientHeight <= maxHeight) {
    return false;
  }
  const lastTextNode = getLastTextNode(el);
  return truncateTextNode(lastTextNode, el, maxHeight);
}
function lineClamp() {
  let {
    element,
    lineCount = 1
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new Promise(resolve => {
    if (!element) {
      resolve(false);
    }
    if (typeof element.style.webkitLineClamp === 'undefined') {
      resolve(truncate(element, lineCount));
    }
    element.style.overflow = 'hidden';
    element.style.textOverflow = 'ellipsis';
    element.style.webkitBoxOrient = 'vertical';
    element.style.display = '-webkit-box';
    element.style.webkitLineClamp = lineCount;
    requestAnimationFrame(() => {
      resolve(element.scrollHeight - 2 > element.clientHeight);
    });
  });
}

export { lineClamp };
//# sourceMappingURL=line-clamp.js.map
